import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles, requireManualTrade }) => {
    const { user, loading } = useContext(AuthContext);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (!allowedRoles.includes(user.role)) {
        return <Navigate to="/accounts" replace />; // Redirect users to /accounts
    }

    const hasRole = allowedRoles.includes(user.role);

    const isAuthorized = user.role === 'admin' || 
    (hasRole && (!requireManualTrade || user.manual_trade === true));

  if (!isAuthorized) {
    return <Navigate to="/" replace />;
  }

    return children;
};

export default ProtectedRoute;